import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { firstValueFrom } from 'rxjs';

export enum UserRole {
  ADMIN = 'admin',
}

export enum UserPermission {
  ChangePassword = 'Users.ChangePassword',
  Impersonate = 'Users.Impersonate',
  ChangeRoles = 'Users.ChangeRoles',
  UserManagement = 'Users.UserManagement',
}

@Entity()
export class User extends AdornisUser<UserPermission> {
  static override _class = 'User';

  @Field(type => String)
  name: Maybe<string>;

  @Field(type => Boolean)
  fromMoodle: Maybe<Boolean>;
}

export const searchUsers = registerQuery({
  type: () => [User],
  operationName: 'searchUsers',
  resolve: search => {
    return async (gqlSelectionSet: BaseQLSelectionSet<User>) => {
      return firstValueFrom(
        User.subscribePaginated<User>(0, 10, {
          username: { $regex: `.*${search}.*`, $options: 'i' },
        }),
      );
    };
  },
  options: {},
  params: [{ type: () => String, name: 'search' }],
});
